import React from 'react';

interface TabGroupIconProps {
  className?: string;
}

/* viewBox padded so the glyph fills ~72% of its box — the band the heroicons beside it
   in the TanTable toolbar occupy. The source art draws 2..22 of 24 (83%), which
   rendered taller than its neighbours at the same h-4 w-4. Padding is on the viewBox,
   not the path, so the artwork is untouched. See ICON SIZING in TanTable.tsx. */
const TabGroupIcon: React.FC<TabGroupIconProps> = ({ className = 'h-4 w-4' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="-1.89 -1.89 27.78 27.78"
      width="512"
      height="512"
      className={className}
      fill="currentColor"
    >
      <path d="M19.5,2H4.5C2.019,2,0,4.019,0,6.5v11c0,2.481,2.019,4.5,4.5,4.5h6c.276,0,.5-.224,.5-.5s-.224-.5-.5-.5H6V8H23v9.5c0,1.93-1.57,3.5-3.5,3.5h-3c-.276,0-.5,.224-.5,.5s.224,.5,.5,.5h3c2.481,0,4.5-2.019,4.5-4.5V6.5c0-2.481-2.019-4.5-4.5-4.5ZM4.5,3h.5V7H1v-.5c0-1.93,1.57-3.5,3.5-3.5Zm.5,18h-.5c-1.93,0-3.5-1.57-3.5-3.5V8H5v13Zm1-14V3h13.5c1.93,0,3.5,1.57,3.5,3.5v.5H6Zm7.732,12.646c.195,.195,.195,.512,0,.707-.098,.098-.226,.146-.354,.146s-.256-.049-.354-.146l-1.439-1.439c-.378-.378-.586-.88-.586-1.414s.208-1.036,.586-1.414l1.439-1.439c.195-.195,.512-.195,.707,0s.195,.512,0,.707l-1.439,1.439c-.063,.063-.116,.133-.159,.207h4.366c.827,0,1.5-.673,1.5-1.5v-4.362c-.075,.042-.145,.093-.207,.155l-1.439,1.439c-.195,.195-.512,.195-.707,0s-.195-.512,0-.707l1.439-1.439c.339-.34,.914-.586,1.414-.586s1.075,.246,1.414,.586l1.439,1.439c.195,.195,.195,.512,0,.707-.098,.098-.226,.146-.354,.146s-.256-.049-.354-.146l-1.439-1.439c-.062-.062-.132-.114-.207-.155v4.362c0,1.379-1.122,2.5-2.5,2.5h-4.366c.043,.074,.096,.144,.159,.207l1.439,1.439Z"/>
    </svg>
  );
};

export default TabGroupIcon;
